import type { RouteRecordRaw } from 'vue-router'

/**
 * Children of the signed-in layout. The pages at /help are the console user
 * guide on every build and, on staging, the tester guide (see helpContent.ts).
 */
export const helpRoutes: RouteRecordRaw[] = [
  {
    // One route for the first page and for every page under it.
    path: 'help/:slug(.*)*',
    name: 'help',
    component: () => import('@/views/HelpView.vue'),
    meta: { titleKey: 'help.title' },
  },
]
